export default {"src":"/_next/static/media/start-auction.0e567aa6.svg","height":24,"width":24};